export default "/images/5825d4aea904373a79635afc58348c8e.avif";